import { createStore } from 'solid-js/store'

export const [store, setStore] = createStore({
  score: 0
})
